import { render, staticRenderFns } from "./Update.vue?vue&type=template&id=18587eb2&scoped=true"
import script from "./Update.vue?vue&type=script&lang=js"
export * from "./Update.vue?vue&type=script&lang=js"
import style0 from "./Update.vue?vue&type=style&index=0&id=18587eb2&prod&scoped=scoped&lang=css"
import style1 from "./Update.vue?vue&type=style&index=1&id=18587eb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18587eb2",
  null
  
)

export default component.exports